import { Component, OnInit, Input,Output, EventEmitter,NgZone, Inject } from '@angular/core';
import {CSRFService} from '../../shared/auth/csrf.service';
import {Subject} from 'rxjs/Subject';
import { NgUploaderOptions, UploadedFile, UploadRejected } from 'ngx-uploader';

@Component( {
    selector: 'dcs-seller-file',
    templateUrl: './seller-file.component.html',
    styles: [ `
    .device-img {
        width: 15rem;
        height: 22rem;
        margin-top: 2rem;
        margina-left: 3rem;
    }
    .drag-n-drop-container {
        border: dotted 3px black ;
        width: 100%;
        height: 22rem;
        text-align: center;
        padding: 1rem
    }
    .hidden { display:none }
    .file-over { border: dotted 3px red; }
    ` ]
} )
export class SellerFileComponent implements OnInit {


    @Output()
    notify: EventEmitter<boolean> = new EventEmitter<boolean>();


    hasBaseDropZoneOver: boolean;
    options: NgUploaderOptions;
    response: any;
    progress: boolean = false;
    sizeLimit: number = 20;
    sizeLimitBytes: number = this.sizeLimit * 1024 * 1024; // 10MB
    errorMessage: string;
    fileName: string;
    inputUploadEvents: EventEmitter<string>;

    constructor(@Inject( NgZone ) private zone: NgZone, private csrfService: CSRFService) {
    }

    ngOnInit() {
        this.options = new NgUploaderOptions( {
            url: '/api/dashboard/seller/upload/file',
            filterExtensions: true,
            allowedExtensions: [ 'pdf', 'epub', 'mobi', 'doc' ],
            // maxSize: 2097152,
            autoUpload: false,
            calculateSpeed: true,
            fieldName: "file",
            fieldReset: true,
            maxUploads: 20,
            method: 'POST',
            multipart: true,
            // previewUrl: true,
            customHeaders: {
                'X-XSRF-TOKEN': this.csrfService.getCSRF()
            },
        } );
        this.inputUploadEvents = new EventEmitter<string>();
    }

    ngOnDestroy(): void {
    }

    startUpload() {
        this.inputUploadEvents.emit( 'startUpload' );
    }

    beforeUpload(uploadingFile: UploadedFile, arg: any): void {
        if (uploadingFile.size > this.sizeLimitBytes) {
            uploadingFile.setAbort();
            console.warn( "File to big " + uploadingFile.size )

            this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.fileToBig';
        }else{
            this.progress = true;
        }
    }


    fileChanged(event) {
        let file;
        if ((file = event.target.files[ 0 ])) {
            this.fileName = file.name;
            if (file.size > this.sizeLimitBytes) {
                this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.fileToBig';
            } else {
                this.errorMessage = null;
            }
        }

    }

    handleUpload(data: any) {
        setTimeout( () => {
            this.zone.run( () => {
                this.response = data;
                if (data && data.response && data.status == 200) {
                    this.response = JSON.parse( data.response );
                    //this.image = JSON.parse( data.response );

                    this.progress = false;
                    //console.log( this.response )
                    this.fileName = null;
                    this.close();
                }
                else{
                    console.log(this.response)
                }
            } );
        } );
    }


    fileOverBase(e: boolean) {
        this.hasBaseDropZoneOver = e;
    }

    close() {
        this.notify.emit( true );
    }

    formatSizeLimit() {
        let sizeLimit = (this.sizeLimit / 1024 / 1024).toPrecision( 1 );
        return sizeLimit;
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-file.component.ts